import React from "react";
import { Handle } from "react-flow-renderer";

export default ({ data, id, ...props }) => {
  // console.log(props);
  const { subTitle = "", title = "" } = data;
  return (
    <>
      <Handle type="source" position="left" id={"sourceLeft"} />
      <Handle type="source" position="top" id={"sourceTop"} />
      <Handle type="source" position="right" id={"sourceRight"} />
      <Handle type="source" position="bottom" id={"sourceBottom"} />
      <div className="node-title">{title}</div>
      <div className="node-subtitle">{subTitle}</div>
      <Handle type="target" position="left" id={"targetLeft"} />
      <Handle type="target" position="top" id={"targetTop"} />
      <Handle type="target" position="right" id={"targetRight"} />
      <Handle type="target" position="bottom" id={"targetBottom"} />
    </>
  );
};
